'use strict';

/*
 * Initializes the PLP recommendation Slick carousel.
 */

$(document).ready(function () {
    if (!($.fn && $.fn.slick)) {
        return;
    }

    var $plpCarouselAll = $('.plp-slick-carousel');
    if ($plpCarouselAll.length) {
        $plpCarouselAll.not('.slick-initialized').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    var $carousel = $('.plp-recommendation .plp-slick-carousel');
    var $container = $carousel.closest('.plp-recommendation');
    if ($carousel.length && $carousel.hasClass('slick-initialized')) {
        var slickInstance = $carousel.slick('getSlick');
        if (slickInstance && slickInstance.slideCount < 1) {
            $container.hide();
        } else {
            $container.find('.carousel-title').removeClass('d-none');
        }
    }

    var einsteinSlickSettings = {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    };

    /**
     * Gets Einstein carousel elements from the given scope or from the whole page.
     *
     * @param {jQuery} $scope Scope element to search inside.
     * @returns {jQuery} Einstein carousel elements.
     */
    function getEinsteinCarousels($scope) {
        if ($scope && $scope.length) {
            return $scope.find('.einstein-slick-carousel').add($scope.filter('.einstein-slick-carousel'));
        }

        return $('.einstein-slick-carousel');
    }

    /**
     * Initializes Einstein slick carousel if it has carousel items and is not already initialized.
     *
     * @param {jQuery} $scope Scope element to search inside.
     */
    function initEinsteinCarousel($scope) {
        var $einsteinCarousel = getEinsteinCarousels($scope)
            .not('.slick-initialized, .cart-slick-carousel, .cart-slicker')
            .filter(function () {
                return $(this).children().length > 0;
            });

        if ($einsteinCarousel.length) {
            $einsteinCarousel.slick(einsteinSlickSettings);
        }
    }

    /**
     * Checks whether all Einstein carousels inside the given root are initialized.
     *
     * @param {HTMLElement} observerRoot Root element being watched.
     * @returns {boolean} True if all Einstein carousels are initialized.
     */
    function isEinsteinCarouselInitialized(observerRoot) {
        var $carousels = $(observerRoot).find('.einstein-slick-carousel');

        return $carousels.length > 0
            && !$carousels.not('.slick-initialized').length;
    }

    /**
     * Watches Einstein recommendation containers and initializes carousel after dynamic content loads.
     */
    function watchEinsteinCarousel() {
        if (typeof MutationObserver === 'undefined') {
            initEinsteinCarousel();
            return;
        }

        $('.einstein-recommendations, .einstein-carousel').each(function () {
            var observerRoot = this;

            // Handles case where Einstein DOM is already present on page load.
            initEinsteinCarousel($(observerRoot));

            // If already initialized, no need to observe this container.
            if (isEinsteinCarouselInitialized(observerRoot)) {
                return;
            }

            var observer = new MutationObserver(function () {
                initEinsteinCarousel($(observerRoot));

                if (isEinsteinCarouselInitialized(observerRoot)) {
                    observer.disconnect();
                }
            });

            observer.observe(observerRoot, {
                childList: true,
                subtree: true
            });
        });
    }

    // Handles Einstein carousel if DOM is already available on page load.
    initEinsteinCarousel();

    // Handles Einstein carousel if DOM loads later dynamically.
    watchEinsteinCarousel();
    // Privilage-static-page
    var $privilageSlick = $('.privilage-slick');
    if ($privilageSlick.length) {
        $privilageSlick.not('.slick-initialized').slick({
            slidesToShow: 2.5,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 375,
                    settings: {
                        slidesToShow: 1.5,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    // heritage-static-page
    var $heritageSlick = $('.heritage-slick-carousel');
    if ($heritageSlick.length) {
        $heritageSlick.not('.slick-initialized').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            arrows: true
        });
    }
});
